<template>
  <div class="conmon-top" id="event-identity">
    <el-container>
      <el-main style="padding: 0" class="table-first-style">
        <div class="top-nav">
          <div @click="chooseSet(index)" :class="isThis === index ? 'choosed' : ''" v-for="(item, index) in navs" :key="index">{{ item }}</div>
        </div>
        <!--属性-->
        <setAttr v-if="isThis === 0"></setAttr>
        <!--等级-->
        <setStage v-if="isThis === 1"></setStage>
        <!--等级-->
        <setOrder v-if="isThis === 2"></setOrder>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { getCustomerEventList, getCustomerStage, editCustomerEvent, createCustomerEvent, deleteCustomerEvent, editNoSystemCustomerEvent, } from '@/api/customer.js'
import { getCusAttrList } from '@/api/set.js'
import setAttr from './../set-center/set-attribute.vue'
import setStage from './../set-center/set-stage.vue'
import setOrder from './../set-center/set-order.vue'
export default {
  name: 'customerEvent',
  data () {
    return {
      navs: ['属性', '等级'],
      isThis: 0
    }
  },
  methods: {
    // 查看订单是否为空，是否显示
    getCustomerAttributeList () {
      let id = this.$route.query.id
      getCusAttrList(id, 1).then((res) => {
        if (res.data.code == 200) {
          if (res.data.result.isHadOrder === 1) {
            this.navs = ['属性', '等级', '订单']
          }
        }
      })
    },
    // 切换
    chooseSet(index) {
      this.isThis = index
    }
  },
  created() {
    this.getCustomerAttributeList()
  },
  components: {
    setAttr,
    setStage,
    setOrder
  }
}
</script>

<style scoped>
  .top-nav{
    width: calc(100% - 40px);
    margin: 0 auto 0;
    border-bottom: 1px solid #dedede;
    height: 50px;
  }
  .top-nav div{
    float: left;
    height: 50px;
    line-height: 50px;
    width: 60px;
    font-size: 14px;
    cursor: pointer;
  }
  .choosed{
    border-bottom: 1px solid #1980FF;
  }
</style>
